import React, { useState, useRef, useEffect } from "react";
import A12Y_CONST from "../common/a12yConst";
import Select from 'react-select';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { isValidPhoneNumber } from 'libphonenumber-js';
import stateList from '../common/stateList.json';
import countyList from '../common/countyList.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Loading from './LoadingComponent';
import LoaderFullScreenComponent from './LoaderFullScreenComponent';
import { ddmmyyyyFormat, dateFromKeyboard } from "../util/date_format";
import { hideOnBlur, readOnlyMobile } from "../util/inputKeyboardHide";
import PopUpNewDependentConfirmation from "./PopUpNewDependentConfirmation";
import PopUpComponent from "./PopUpComponent";
import { useDispatch, useSelector } from "react-redux";
import * as userDetailActions from "../redux/actions/userDetailActions";
import { currencyFormatting } from "../util/CurrencyFormater";

// Gender options matching DependentProfileEditComponent exactly
const genderOptions = [
  { value: 'M', label: 'M' },
  { value: 'F', label: 'F' },
  { value: 'X', label: 'X' },
];

const phoneTypeList = [
  { value: 'select', label: 'Select' },
  { value: 'mobile', label: 'Mobile' },
  { value: 'home', label: 'Home' },
  { value: 'work', label: 'Work' },
  { value: 'other', label: 'Other' }
];

const stateOptions = stateList.map(state => ({ label: state.label, value: state.label }));

function AddNewDependentComponent({ 
  onSubmit, 
  onCancel, 
  loading, 
  error, 
  errorMessage,
  isQuotaFull,
  totalAllowed,
  currentCount,
  subscription,
  subscriptionType,
  isTrialExpired
}) {
  const fileInputRef = useRef(null);
  const dobDateRef = useRef(null);
  const appointDateRef = useRef(null);

  const handleChangeRaw = (e, elmName) => {
    let val = e.target.value
    if(typeof val !== 'object' && val !== undefined){
      document.getElementsByName(elmName)[0].value = dateFromKeyboard(val)
    }
  }

  useEffect(() => {
    let arr = [appointDateRef.current, dobDateRef.current];
    readOnlyMobile(arr);
  }, []);

  const [avatarPreview, setAvatarPreview] = useState(null);
  const [avatarFile, setAvatarFile] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [errors, setErrors] = useState({});
  const [isNewPopUp, setIsNewPopUp] = useState(false);
  const [popUpType, setPopUpType] = useState("");
  const [pendingData, setPendingData] = useState(null);
  const [isCancelPopUp, setIsCancelPopUp] = useState(false);

  const dispatch = useDispatch();
  const proratedAmount = useSelector(state => state.userDetailReducer.proratedAmount);
  const nextBill = useSelector(state => state.userDetailReducer.nextBill);

  useEffect(() => {
    const subscriptionStatus = subscriptionType?.toLowerCase();
    if (
      subscriptionStatus === 'canceled' ||
      subscriptionStatus === 'cancelled' ||
      (subscriptionStatus === 'past_due' && subscription?.is_trial_expired) ||
      isTrialExpired ||
      isQuotaFull
    ) {
      // if (subscriptionStatus === 'canceled' || subscriptionStatus === 'cancelled' || (subscriptionStatus === 'past_due' && subscription?.is_trial_expired)) {
      //   setPopUpType(A12Y_CONST.LABEL.CANCELLED);
      // } else if (isTrialExpired) {
      //   setPopUpType(A12Y_CONST.LABEL.TRIAL_HAS_EXPIRED);
      // } else if (isQuotaFull) {
      //   setPopUpType(A12Y_CONST.LABEL.QUOTA_LIMIT_REACHED);
      // }

       if (isTrialExpired) {
        setPopUpType(A12Y_CONST.LABEL.TRIAL_HAS_EXPIRED);
      } else if (isQuotaFull) {
        setPopUpType(A12Y_CONST.LABEL.QUOTA_LIMIT_REACHED);
      }
      setIsNewPopUp(true);
    }
  }, []);

  // Phone states
  const [selectedPhoneType1, setSelectedPhoneType1] = useState({});
  const [selectedPhoneType2, setSelectedPhoneType2] = useState({});
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumber_2, setPhoneNumber_2] = useState("");
  const [phoneType1LabelActive, setPhoneType1LabelActive] = useState(false);
  const [phoneType2LabelActive, setPhoneType2LabelActive] = useState(false);
  const [phoneNumber_1ErrorMessage, setPhoneNumber_1ErrorMessage] = useState('');
  const [phoneNumber_2ErrorMessage, setPhoneNumber_2ErrorMessage] = useState('');
  const [phoneNumberError, setphoneNumberError] = useState(false);
  const [phoneNumber2Error, setphoneNumber2Error] = useState(false);
  const [isPhone2DropdownSelect, setIsPhone2DropdownSelect] = useState(false);

  const handlePhoneField = e => {
    if(e.length > 1){
      setPhoneType1LabelActive(true)
    }else{
      setPhoneType1LabelActive(false);
    }
    setPhoneNumber(e)
  }

  const onBlurEventHandlerPhone = () => {
    if(phoneNumber.length > 1){
      const isValid =  validatePhoneNumber(phoneNumber)
      if(!isValid){
        setphoneNumberError(true)
        setPhoneNumber_1ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PHONE_NUMBER_IS_INVALID)
      }else {
        setphoneNumberError(false)
        setPhoneNumber_1ErrorMessage('')
      }
    }
  }

  const validatePhoneNumber = (e) => {
    const validNumber = '+'+e.toString()
    const phoneNumber = isValidPhoneNumber(validNumber)
    return phoneNumber
  }

  const handlePhoneField_2 = e => {
    if(e.length > 1){
      setPhoneType2LabelActive(true)
    }else{
      setPhoneType2LabelActive(false);
    }
    setPhoneNumber_2(e)
  }

  const onBlurEventHandlerPhone2 = () => {
    const isValid =  validatePhoneNumber(phoneNumber_2)
    if(phoneNumber_2.length > 1 && !isValid){
      setphoneNumber2Error(true)
      setPhoneNumber_2ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PHONE_NUMBER_IS_INVALID)
    }else {
      setphoneNumber2Error(false)
      setPhoneNumber_2ErrorMessage('')
    }
  }

  const handleChangePhoneType1 = (val) => {
    setSelectedPhoneType1(val)
    if(val.label !== 'Select'){
      setPhoneType1LabelActive(true)
    }else {
      setPhoneType1LabelActive(false)
      setPhoneNumber('')
      setphoneNumberError(false)
    }
  }

  const handleChangePhoneType2 = (val) => {
    setSelectedPhoneType2(val)
    if(val.label !== 'Select'){
      setPhoneType2LabelActive(true)
    }else {
      setPhoneType2LabelActive(false)
      setPhoneNumber_2('')
      setphoneNumber2Error(false)
    }
  }

  // Address states
  const [countryState, setCountryState] = useState({});
  const [county, setCounty] = useState({});
  const [billingRate, setBillingRate] = useState('');
  const [billingRateError, setBillingRateError] = useState(false);
  const [billingRateErrorMessage, setBillingRateErrorMessage] = useState('');

  const handleBillingRateChange = async (val) => {
    let rate = val.trim()
    if (rate === '') {
      setBillingRate(rate)
    } else {
      let temp = await currencyFormatting(rate);
      if (temp !== undefined) {
        setBillingRate(temp)
      }
    }
    if (errors.billing_rate) setErrors((prev) => ({ ...prev, billing_rate: null }));
  };

  const validateBillingRate = () => {
    let rate = billingRate.replaceAll(',', '')
    if (rate === '') {
      setBillingRateError(false)
      setBillingRateErrorMessage('');
      return false;
    } else if (isNaN(rate) || parseFloat(rate) < 0) {
      setBillingRateError(true)
      setBillingRateErrorMessage('Enter a valid hourly rate.');
      return true;
    } else if (parseFloat(rate) > 999999) {
      setBillingRateError(true)
      setBillingRateErrorMessage('Hourly rate must be less than 1,000,000.');
      return true;
    } else {
      setBillingRateError(false)
      setBillingRateErrorMessage('');
      return false;
    }
  };

  const [form, setForm] = useState({
    first_name:       "",
    last_name:        "",
    nick_name:        "",
    dob:              "",
    gender:           "",
    email:            "",
    case_file_number: "",
    appointment_date: "",
    address1:         "",
    address2:         "",
    city:             "",
    zip:              "",
    advocate_ref_id:  "",
  });
  const [dobDate, setDobDate] = useState(null);
  const [appointmentDate, setAppointmentDate] = useState(null);

  const set = (field) => (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: null }));
  };

  const handleGenderChange = (val) => {
    setForm((prev) => ({ ...prev, gender: val }));
    if (errors.gender) setErrors((prev) => ({ ...prev, gender: null }));
  };

  const countyOptions = countyList[countryState.label] 
    ? countyList[countryState.label].map(c => ({ label: c.label, value: c.label }))
    : [];

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAvatarFile(file);
    const reader = new FileReader();
    reader.onload = (ev) => {
      setAvatarPreview(ev.target.result);
      setImageLoaded(false);
    };
    reader.readAsDataURL(file);
  };

  const validate = () => {
    const errs = {};
    if (!form.first_name.trim()) errs.first_name = A12Y_CONST.ERROR_MESSAGE.SIGNUP_FIRST_NAME_REQUIRED;
    if (!form.last_name.trim())  errs.last_name  = A12Y_CONST.ERROR_MESSAGE.SIGNUP_LAST_NAME_REQUIRED;
    if (!dobDate)               errs.dob        = "Date of birth is required.";
    if (!form.gender)            errs.gender     = "Please select a gender.";
    if (!appointmentDate)        errs.appointment_date = "Date Appointed is required.";
    if (!form.case_file_number.trim()) errs.case_file_number = "Case Number is required.";
    if (!countryState || !countryState.label) errs.countryState = "State is required.";
    if (!county || !county.label) errs.county = "County is required.";
    if (form.email && !/^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(form.email))
      errs.email = A12Y_CONST.ERROR_MESSAGE.SIGNUP_USERNAME_INVALID;
    
    let rate = billingRate.replaceAll(',', '')
    if (rate !== '') {
      if (isNaN(rate) || parseFloat(rate) < 0) {
        errs.billing_rate = "Enter a valid hourly rate.";
      } else if (parseFloat(rate) > 999999) {
        errs.billing_rate = "Hourly rate must be less than 1,000,000.";
      }
    }
    return errs;
  };

  const isFormDirty = () => {
    return (
      billingRate !== '' ||
      form.first_name.trim() !== '' ||
      form.last_name.trim() !== '' ||
      form.nick_name.trim() !== '' ||
      form.email.trim() !== '' ||
      form.case_file_number.trim() !== '' ||
      form.appointment_date !== '' ||
      form.advocate_ref_id.trim() !== '' ||
      form.address1.trim() !== '' ||
      form.address2.trim() !== '' ||
      form.city.trim() !== '' ||
      form.zip.trim() !== '' ||
      dobDate !== null ||
      appointmentDate !== null ||
      form.gender !== '' ||
      phoneNumber !== '' ||
      phoneNumber_2 !== '' ||
      Object.keys(countryState).length > 0 ||
      Object.keys(county).length > 0 ||
      avatarFile !== null
    );
  };

  const handleCancelClick = () => {
    if (isFormDirty()) {
      setIsCancelPopUp(true);
    } else {
      onCancel();
    }
  };

  const hideCancelPopUp = () => {
    setIsCancelPopUp(false);
  };

  const handleConfirmCancel = () => {
    setIsCancelPopUp(false);
    onCancel();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let IsPhone1DropdownSelected = false;
    let IsPhone2DropdownSelected = false;
    let phoneError = false;

    onBlurEventHandlerPhone();
    if (phoneNumber.length > 1 && phoneNumber !== "1" && (Object.keys(selectedPhoneType1).length === 0 || selectedPhoneType1.value === 'select')) {
      phoneError = true;
      setphoneNumberError(true);
      setIsPhone2DropdownSelect(true);
      IsPhone1DropdownSelected = true;
      setPhoneNumber_1ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PLEASE_SELECT_PHONE_TYPE);
    } else {
      if (selectedPhoneType1.value && selectedPhoneType1.value !== 'select' && (phoneNumber === "" || phoneNumber === "1")) {
        phoneError = true;
        setphoneNumberError(true);
        setPhoneNumber_1ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PHONE_NUMBER_IS_INVALID);
      } else {
        if (phoneNumber.length > 1) {
          const isValid = validatePhoneNumber(phoneNumber);
          if (!isValid) {
            phoneError = true;
            setphoneNumberError(true);
            setPhoneNumber_1ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PHONE_NUMBER_IS_INVALID);
          }
        }
      }
    }

    onBlurEventHandlerPhone2();
    if (phoneNumber_2.length > 1 && phoneNumber_2 !== "1" && (Object.keys(selectedPhoneType2).length === 0 || selectedPhoneType2.value === 'select')) {
      phoneError = true;
      setIsPhone2DropdownSelect(true);
      IsPhone2DropdownSelected = true;
      setphoneNumber2Error(true);
      setPhoneNumber_2ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PLEASE_SELECT_PHONE_TYPE);
    } else {
      if (selectedPhoneType2.value && selectedPhoneType2.value !== 'select' && (phoneNumber_2 === "" || phoneNumber_2 === "1")) {
        phoneError = true;
        setphoneNumber2Error(true);
        setPhoneNumber_2ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PHONE_NUMBER_IS_INVALID);
      } else {
        if (phoneNumber_2.length > 1) {
          const isValid = validatePhoneNumber(phoneNumber_2);
          if (!isValid) {
            phoneError = true;
            setphoneNumber2Error(true);
            setPhoneNumber_2ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PHONE_NUMBER_IS_INVALID);
          }
        }
      }
    }

    const errs = validate();
    if (Object.keys(errs).length > 0 || phoneError || phoneNumberError || phoneNumber2Error || IsPhone2DropdownSelected || IsPhone1DropdownSelected) { 
      setErrors(errs); 
      return; 
    }

    const phoneList = [
      { type: selectedPhoneType1.value && selectedPhoneType1.value !== 'select' ? selectedPhoneType1.value : '', number: phoneNumber },
      { type: selectedPhoneType2.value && selectedPhoneType2.value !== 'select' ? selectedPhoneType2.value : '', number: phoneNumber_2 }
    ].filter(p => p.number);

    const payload = {
      first_name:       form.first_name.trim(),
      last_name:        form.last_name.trim(),
      nick_name:        form.nick_name.trim(),
      dob:              dobDate ? ddmmyyyyFormat(dobDate) : null,
      gender:           form.gender,
      email:            JSON.stringify({ email: form.email.trim() }),
      phone:            JSON.stringify(phoneList),
      case_file_number: form.case_file_number.trim(),
      advocord_ref_id:  form.advocate_ref_id.trim(),
      county:           JSON.stringify([{ state: countryState.label || "", county: county.label || "" }]),
      appointment_date: appointmentDate ? ddmmyyyyFormat(appointmentDate) : null,
      address: {
        address1: form.address1.trim(),
        address2: form.address2.trim(),
        city:     form.city.trim(),
        zip:      form.zip.trim(),
      },
    };
    
    if (billingRate !== undefined && billingRate !== null && String(billingRate).trim() !== '') {
      payload.billing_rate = billingRate.replaceAll(',', '');
    }

   
    // if (subscriptionType?.toLowerCase() === 'canceled' || subscriptionType?.toLowerCase() === 'cancelled' || (subscriptionType?.toLowerCase() === 'past_due' && subscription?.is_trial_expired) ) {
    //   setPendingData({ payload, avatarFile });
    //   setPopUpType(A12Y_CONST.LABEL.CANCELLED);
    //   setIsNewPopUp(true);
    // } else if (isTrialExpired) {
    //   setPendingData({ payload, avatarFile });
    //   setPopUpType(A12Y_CONST.LABEL.TRIAL_HAS_EXPIRED);
    //   setIsNewPopUp(true);
    // } else if (isQuotaFull) {
    //   setPendingData({ payload, avatarFile });
    //   setPopUpType(A12Y_CONST.LABEL.QUOTA_LIMIT_REACHED);
    //   setIsNewPopUp(true);
    // } else {
    //   onSubmit(payload, avatarFile);
    // }
    onSubmit(payload, avatarFile);
  };

  const isBtnDisabled = !form.first_name.trim() ||
                        !form.last_name.trim() ||
                        !dobDate ||
                        !form.gender ||
                        !appointmentDate ||
                        !form.case_file_number.trim() ||
                        !countryState || !countryState.label ||
                        !county || !county.label;

  return (
    <div className="titleRow myProfileViewAccount">
      {loading && <LoaderFullScreenComponent />}
      {/* ── Page Header ── */}
      <div className="titleNameAndTabHeader" id="TitleNameAndTabHeader">
        <h2 className="titleWithSidebar marginBottom30 headerFixed df aic">
          <button
            className="cursorPointer backArrow bgTransparent borderNone marginRight20 df aic"
            onClick={handleCancelClick}
            type="button"
          >
            <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.652 16.5323C10.3215 15.8818 10.3355 14.8104 9.68334 14.1426L4.19094 8.5042L9.82931 3.01176C10.4988 2.3613 10.5128 1.28991 9.86065 0.622118C9.21019 -0.047358 8.13868 -0.0614097 7.47089 0.590778L0.621993 7.26237C-0.0474648 7.91283 -0.0615151 8.98422 0.590655 9.65201L7.26225 16.5009C7.91271 17.1704 8.98421 17.1844 9.652 16.5323Z" fill="#112e53"/>
            </svg>
          </button>
          {A12Y_CONST.LABEL.ADD_DEPENDENT}
        </h2>
      </div>

      {/* ── Content ── */}
      <div className="fullWidth">
        <div className="dependentBorderBox dependentProile_Edit_resposnive">
          <div className="fullWidth DependentStep1FormCol paddingBottom100 positionRelative">
            {error && (
              <div className="maxWidth600 marginLeftRightAuto">
                <div className="errorRelativeRow"><p className="errorMessage">{errorMessage || "Something went wrong."}</p></div>
              </div>
            )}

            <form onSubmit={handleSubmit} className="paddingTop20 marginTop40 dependentEditProfile" autoComplete="off" noValidate>
              {/* ── Profile Photo ── */}
              <div className="generalInfoTitle fullWidth positionRelative marginBottom30">
                <div className="generalInfoProfileImg dependentPro cursorPointer overflowHidden">
                  <div className="dependentImgageCol overflowHidden">
                    <label className="custom-file-uploadImage">
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleAvatarChange}
                      />
                      {avatarPreview ? (
                        <>
                          {!imageLoaded && (
                            <div className="picLoader">
                              <div className="fullWidth justifyCenter marginBottom10" style={{ height: 15 }}>
                                <div className="stage"><div className="dot-pulse"></div></div>
                              </div>
                            </div>
                          )}
                          <img alt="" onLoad={() => setImageLoaded(true)} src={avatarPreview} />
                        </>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 144 144" fill="none">
                          <circle cx="72" cy="72" r="72" fill="#E2EDF8"/>
                          <circle cx="71.9999" cy="72.0008" r="63.4286" fill="#A1C4E7"/>
                          <path d="M100.694 100.305C101.284 100.182 101.633 99.569 101.405 99.0115C99.4978 94.3457 95.7962 90.2359 90.7842 87.2447C85.3952 84.0285 78.7923 82.2852 71.9996 82.2852C65.2069 82.2852 58.604 84.0285 53.2149 87.2447C48.2029 90.2359 44.5014 94.3457 42.5937 99.0115C42.3657 99.5689 42.7154 100.182 43.305 100.305L63.8387 104.584C69.2214 105.706 74.7777 105.706 80.1604 104.584L100.694 100.305Z" fill="#F1F8FF"/>
                          <ellipse cx="71.9998" cy="58.2854" rx="17.1429" ry="17.1429" fill="#F1F8FF"/>
                        </svg>
                      )}
                    </label>
                  </div>
                </div>
                <div className="generalInfoUserName">
                  {A12Y_CONST.LABEL.DEPENDENT_PROFILE}
                </div>
              </div>

              {/* ── Personal Information ── */}
              <div className="dependentSubTitle marginBottom30">
                {A12Y_CONST.LABEL.DEPENDENT_INFORMATION}
              </div>

              {/* First Name / Last Name */}
              <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol">
                  {A12Y_CONST.LABEL.GAURDIAN_PROFILE_PERSONAL_INFO_NAME}
                  <span className="astrciBlue">*</span>
                </label>
                <div className="fullWidth">
                  <div className="width50 paddingRight16 myProfile_personal_FirstName600">
                    <input
                      placeholder="First Name"
                      className={errors.first_name ? 'inputColum24size errorInputBorderRed' : 'inputColum24size'}
                      type="text"
                      id="userFirstName"
                      autoComplete="none"
                      maxLength="100"
                      value={form.first_name}
                      onChange={set("first_name")}
                      onBlur={() => {
                        if (!form.first_name.trim()) setErrors((prev) => ({ ...prev, first_name: A12Y_CONST.ERROR_MESSAGE.SIGNUP_FIRST_NAME_REQUIRED }));
                      }}
                    />
                    <div className="errorRelativeRow">
                      {errors.first_name && <p className="errorMessage">{errors.first_name}</p>}
                    </div>
                  </div>
                  <div className="width50 paddingleft16 responsive6000LeftRight">
                    <input
                      placeholder="Last Name"
                      className={errors.last_name ? 'inputColum24size errorInputBorderRed' : 'inputColum24size'}
                      type="text"
                      id="userLastName"
                      autoComplete="none"
                      maxLength="100"
                      value={form.last_name}
                      onChange={set("last_name")}
                      onBlur={() => {
                        if (!form.last_name.trim()) setErrors((prev) => ({ ...prev, last_name: A12Y_CONST.ERROR_MESSAGE.SIGNUP_LAST_NAME_REQUIRED }));
                      }}
                    />
                    <div className="errorRelativeRow">
                      {errors.last_name && <p className="errorMessage">{errors.last_name}</p>}
                    </div>
                  </div>
                </div>
              </div>

              {/* DOB */}
              <div className="dependentStepFormRow fullWidth marginBottom30 positionRelative">
                <label className="labelCol positionAbsoute">{A12Y_CONST.LABEL.DEPENDENT_DOB}<span className="astrciBlue">*</span></label>
                <div className="fullWidth">
                  <div className="width50 maxWidth388 dtPickerWrap">
                    <DatePicker
                      ref={dobDateRef}
                      name="dob"
                      selected={dobDate}
                      onChange={(date) => { setDobDate(date); if (errors.dob) setErrors((prev) => ({ ...prev, dob: null })); }}
                      onChangeRaw={(event) => handleChangeRaw(event, 'dob')}
                      onKeyDown={(event) => hideOnBlur(event, dobDateRef)}
                      onCalendarClose={() => {
                        if (!dobDate) setErrors((prev) => ({ ...prev, dob: "Date of birth is required." }));
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      dateFormat="MM / dd / yyyy"
                      placeholderText="MM / DD / YYYY"
                      maxDate={new Date()}
                      className={errors.dob ? 'inputColum24size dtPicker errorInputBorderRed' : 'inputColum24size dtPicker'}
                    />
                    <div className="errorRelativeRow">
                      {errors.dob && <p className="errorMessage">{errors.dob}</p>}
                    </div>
                  </div>
                </div>
              </div>

              {/* Gender */}
              <div className="dependentStepFormRow fullWidth marginBottom30 positionRelative">
                <label className="labelCol">{A12Y_CONST.LABEL.DEPENDENT_GENDER}<span className="astrciBlue">*</span></label>
                <div className="fullWidth">
                  <div className="dependentGenderCol maxWidth338">
                    {genderOptions.map((item, i) => (
                      <label key={i}>
                        <input
                          id={item.value + A12Y_CONST.LABEL.DEPENDENT_GENDER}
                          type="radio"
                          checked={form.gender === item.value}
                          onChange={() => handleGenderChange(item.value)}
                          onBlur={() => {
                            if (!form.gender) setErrors((prev) => ({ ...prev, gender: "Please select a gender." }));
                          }}
                          value={item.value}
                        />
                        <span>{item.label}</span>
                      </label>
                    ))}
                  </div>
                  <div className="errorRelativeRow">
                    {errors.gender && <p className="errorMessage">{errors.gender}</p>}
                  </div>
                </div>
              </div>

              {/* Display Name */}
              {/* <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol">{A12Y_CONST.LABEL.DEPENDENT_DISPLAY_NAME}</label>
                <div className="fullWidth">
                  <input
                    placeholder="&nbsp;"
                    className={`inputColum24size ${form.nick_name.length === 0 ? 'noText' : ''}`}
                    type="text"
                    id="displayName"
                    maxLength="100"
                    autoComplete="none"
                    value={form.nick_name}
                    onChange={set("nick_name")}
                  />
                  <div className="errorRelativeRow">
                      {errors.nick_name && <p className="errorMessage">{errors.nick_name}</p>}
                  </div>
                </div>
              </div> */}

              {/* ── Contact Information ── */}
              <div className="dependentSubTitle marginBottom30">
                {A12Y_CONST.LABEL.CONTACT_INFORMATION}
              </div>

              {/* Email */}
              <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol">{A12Y_CONST.LABEL.DEPENDENT_EMAIL}</label>
                <div className="fullWidth">
                  <input
                    placeholder="name@example.com"
                    className={errors.email ? 'inputColum24size errorInputBorderRed' : 'inputColum24size'}
                    type="text"
                    id="emailField"
                    autoComplete="none"
                    value={form.email}
                    onChange={set("email")}
                  />
                  <div className="errorRelativeRow">
                    {errors.email && <p className="errorMessage">{errors.email}</p>}
                  </div>
                </div>
              </div>

              {/* Phone */}
              <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol phoneEditProfile">{A12Y_CONST.LABEL.DEPENDENT_PHONE}</label>
                <div className="fullWidth">
                  <div className="width50 paddingRight16 selectBoxParend myProfilePhoneCol1_600">
                    <div className={(selectedPhoneType1.value && selectedPhoneType1.value !== 'select' ? 'hasValue ' : 'noValue ') + 'fullWidth phoneTypeCol positionAbsouteTop4 positionTop maxWidth138px phoneDropDownResponsiveCol'}>
                      <Select
                        className="phoneTypeLabel"
                        classNamePrefix={phoneType1LabelActive? 'phoneNumberActive phoneType1' : 'phoneType1'}
                        placeholder="Select"
                        value={selectedPhoneType1.label ? selectedPhoneType1 : ""}
                        options={phoneTypeList}
                        onChange={handleChangePhoneType1}
                        theme={(theme) => ({ ...theme, borderRadius: 0, colors: { ...theme.colors, primary: '#0096C708' } })}
                      />
                    </div>
                    <PhoneInput
                      country='us'
                      countryCodeEditable={false}
                      disabled={Object.keys(selectedPhoneType1).length > 0 && selectedPhoneType1.label === 'Select' ? true : false}
                      containerClass={phoneType1LabelActive ? phoneNumberError ?  'errorInputBorderRedInput phoneNumber_Active': phoneNumber === "1" ? 'phone_number_placeholder_color null' : 'phoneNumber_Active'  : phoneNumberError? 'errorInputBorderRedInput': null}
                      value={phoneNumber}
                      onBlur={onBlurEventHandlerPhone}
                      onChange={phone => {handlePhoneField(phone)}}
                      onFocus={() => setphoneNumberError(false)}
                      inputProps={{ name: 'phone', required: false }}
                    />
                    <div className='errorRelativeRow'> {phoneNumberError ? <p className='errorMessage'>{phoneNumber_1ErrorMessage}</p> : null }</div>
                  </div>
                  <div className="width48 floatRight paddingleft16 selectBoxParend myProfilePhoneCol2_600">
                    <div className={(selectedPhoneType2.value && selectedPhoneType2.value !== 'select' ? 'hasValue ' : 'noValue ') + 'fullWidth phoneTypeCol positionAbsouteTop4 positionTop maxWidth138px phoneDropDownResponsiveCol'}>
                      <Select
                        className="phoneTypeLabel"
                        classNamePrefix={phoneType2LabelActive? 'phoneNumberActive phoneType1' : 'phoneType1'}
                        placeholder="Select"
                        value={selectedPhoneType2.label ? selectedPhoneType2 : ""}
                        options={phoneTypeList}
                        onChange={handleChangePhoneType2}
                        theme={(theme) => ({ ...theme, borderRadius: 0, colors: { ...theme.colors, primary: '#0096C708' } })}
                      />
                    </div>
                    <PhoneInput
                      country='us'
                      countryCodeEditable={false}
                      disabled={Object.keys(selectedPhoneType2).length > 0 && selectedPhoneType2.label === 'Select' ? true : false}
                      containerClass={phoneType2LabelActive ? phoneNumber2Error? 'errorInputBorderRedInput phoneNumber_Active': phoneNumber_2 === "1" ? 'phone_number_placeholder_color null' :'phoneNumber_Active' : phoneNumber2Error? 'errorInputBorderRedInput': null}
                      value={phoneNumber_2}
                      onBlur={onBlurEventHandlerPhone2}
                      onChange={phone => {handlePhoneField_2(phone)}}
                      onFocus={() => {
                        setphoneNumber2Error(false)
                        setIsPhone2DropdownSelect(false)
                      }}
                      inputProps={{ name: 'phone2', required: false }}
                    />
                    <div className='errorRelativeRow'> {phoneNumber2Error || isPhone2DropdownSelect? <p className='errorMessage'>{phoneNumber_2ErrorMessage}</p> : null }</div>
                  </div>
                </div>
              </div>

              {/* ── Guardian / Legal Authority ── */}
              <div className="dependentSubTitle marginBottom30">
                {A12Y_CONST.LABEL.LEGAL_AUTHORITY}
              </div>

              {/* Appointed Date */}
              <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol label_guardianApp">{A12Y_CONST.LABEL.DEPENDENT_DATE_APPOINTED} <span className="astrciBlue">*</span> </label>
                 
                <div className="fullWidth maxWidth388 dtPickerWrap">
                  <DatePicker
                    ref={appointDateRef}
                    name="appointment_date"
                    selected={appointmentDate}
                    onChange={(date) => { setAppointmentDate(date); if (errors.appointment_date) setErrors((prev) => ({ ...prev, appointment_date: null })); }}
                    onChangeRaw={(event) => handleChangeRaw(event, 'appointment_date')}
                    onKeyDown={(event) => hideOnBlur(event, appointDateRef)}
                    onCalendarClose={() => {
                      if (!appointmentDate) setErrors((prev) => ({ ...prev, appointment_date: "Date Appointed is required." }));
                    }}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    dateFormat="MM / dd / yyyy"
                    placeholderText="MM / DD / YYYY"
                    className={errors.appointment_date ? 'inputColum24size dtPicker errorInputBorderRed' : 'inputColum24size dtPicker'}
                  />
                  <div className="errorRelativeRow">
                    {errors.appointment_date && <p className="errorMessage">{errors.appointment_date}</p>}
                  </div>
                </div>
              </div>

              {/* Case Number */}
              <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol">{A12Y_CONST.LABEL.DEPENDENT_CASE_NUMBER} <span className="astrciBlue">*</span> </label>
                <div className="fullWidth">
                  <input
                    placeholder="Case / File Number"
                    className={errors.case_file_number ? 'inputColum24size errorInputBorderRed' : 'inputColum24size'}
                    type="text"
                    id="caseNumber"
                    maxLength="255"
                    autoComplete="none"
                    value={form.case_file_number}
                    onChange={set("case_file_number")}
                    onBlur={() => {
                      if (!form.case_file_number.trim()) setErrors((prev) => ({ ...prev, case_file_number: "Case Number is required." }));
                    }}
                  />
                  <div className="errorRelativeRow">
                    {errors.case_file_number && <p className="errorMessage">{errors.case_file_number}</p>}
                  </div>
                </div>
              </div>

              <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol">{A12Y_CONST.LABEL.ADVOCORD_REF_ID}</label>
                <div className="fullWidth">
                  <input
                    placeholder=''
                    className="inputColum24size"
                    type="text"
                    id="advocateRefId"
                    maxLength="100"
                    autoComplete="none"
                    value={form.advocate_ref_id}
                    onChange={set("advocate_ref_id")}
                  />
                </div>
              </div>

              {/* State & County */}
              <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol">{A12Y_CONST.LABEL.STATE} <span className="astrciBlue">*</span> </label>
                <div className="fullWidth">
                  <div className="width50 paddingRight16 countryState">
                    <div className={(countryState.label ? 'hasValue' : 'noValue') + ' fullWidth dependentResidencCol' + (errors.countryState ? ' errorInputBorderRed' : '')}>
                      <Select
                        classNamePrefix={'dependentResidence'}
                        placeholder="Select"
                        value={countryState.label ? countryState : ""}
                        options={stateOptions}
                        onChange={(val) => { setCountryState(val); setCounty({}); setErrors((prev) => ({ ...prev, countryState: null, county: null })); }}
                        theme={(theme) => ({ ...theme, borderRadius: 0, colors: { ...theme.colors, primary: '#0096C708' } })}
                        menuPlacement="top"
                      />
                    </div>
                    <div className="errorRelativeRow">
                      {errors.countryState && <p className="errorMessage">{errors.countryState}</p>}
                    </div>
                  </div>
                  <div className="width48 floatRight paddingleft16 countryState">
                    <div className={(county.label ? 'hasValue' : 'noValue') + ' fullWidth dependentResidencCol positionRelative addressRow'}>
                      <label className="labelCol institutionStateLabel">{A12Y_CONST.LABEL.COUNTY} <span className="astrciBlue">*</span> </label>
                      <>
                      <Select
                        classNamePrefix={'dependentResidence'}
                        placeholder="Select"
                        value={county.label ? county : ""}
                        options={countyOptions}
                        onChange={(val) => { setCounty(val); setErrors((prev) => ({ ...prev, county: null })); }}
                        theme={(theme) => ({ ...theme, borderRadius: 0, colors: { ...theme.colors, primary: '#0096C708' } })}
                        isDisabled={!countryState.label}
                        menuPlacement="top"
                        className={`${errors.county ? ' errorInputBorderRed' : ''}`}
                      />
                      <div className="errorRelativeRow">
                      {errors.county && <p className="errorMessage">{errors.county}</p>}
                      </div>
                      </>
                    </div>
                    
                  </div>
                </div>
              </div>

              {/* Billing Rate */}
              <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol">{A12Y_CONST.LABEL.HOURLY_RATE}</label>
                <div className="fullWidth">
                  <div className="amountWrap maxWidth338">
                    <span className={billingRate.length < 1 ? "currency" : "currency currencyColorChnage"}>$</span>
                    <input
                      placeholder="0.00"
                      type="text"
                      min="0"
                      inputMode="decimal"
                      id="billingRate"
                      onWheel={e => e.target.blur()}
                      onChange={(e) => handleBillingRateChange(e.target.value)}
                      value={billingRate}
                      maxLength={14}
                      onBlur={validateBillingRate}
                      onFocus={() => {
                        setBillingRateError(false);
                        if (errors.billing_rate) setErrors((prev) => ({ ...prev, billing_rate: null }));
                      }}
                      className={`fullWidth txtAmount inputColum24size ${errors.billing_rate ? 'errorInputBorderRed' : ''}`}
                    />
                    <div className="errorRelativeRow">
                      {errors.billing_rate && <p className="errorMessage">{errors.billing_rate}</p>}
                    </div>
                  </div>
                </div>
              </div>

              {/* ── Address ── */}
              {/* <div className="dependentSubTitle marginBottom30">
                {A12Y_CONST.LABEL.GAURDIAN_PROFILE_PERSONAL_INFO_ADDRESS}
              </div> */}

              {/* Street Address 1 & 2 */}
              {/* <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol">{A12Y_CONST.LABEL.ADDRESS_1}</label>
                <div className="fullWidth">
                  <div className="width50 paddingRight16">
                    <input
                      placeholder="Street Address"
                      className="inputColum24size"
                      type="text"
                      value={form.address1}
                      onChange={set("address1")}
                    />
                  </div>
                  <div className="width50 paddingleft16">
                    <input
                      placeholder="Apartment, Suite, Unit, Building"
                      className="inputColum24size"
                      type="text"
                      value={form.address2}
                      onChange={set("address2")}
                    />
                  </div>
                </div>
              </div> */}

              {/* City, State */}
              {/* <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol">{A12Y_CONST.LABEL.CITY}</label>
                <div className='fullWidth positionRelative'>
                  <div className='fullWidth marginBottom10 cityCountryState'>
                    <div className='width40 paddingRight35 marginBottom30 city'>
                      <input
                        placeholder="City"
                        className="inputColum24size"
                        type="text"
                        value={form.city}
                        onChange={set("city")}
                      />
                    </div>
                    <div className='width60 dependentResidencCol paddingLeft35 countryState'>
                      <div className={(countryState.label ? 'hasValue' : 'noValue') + ' fullWidth dependentResidencCol floatLeft marginTop10 positionRelative paddingLeft35 addressRow countryState'}>
                        <label className='labelCol institutionStateLabel'>{A12Y_CONST.LABEL.STATE}</label>
                        <Select
                          classNamePrefix={'dependentResidence'}
                          placeholder="Select"
                          value={countryState.label ? countryState : ""}
                          options={stateOptions}
                          onChange={(val) => { setCountryState(val); setCounty({}); }}
                          theme={(theme) => ({ ...theme, borderRadius: 0, colors: { ...theme.colors, primary: '#0096C708' } })}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* ZIP, County */}
              {/* <div className="dependentStepFormRow fullWidth marginBottom40 positionRelative">
                <label className="labelCol">{A12Y_CONST.LABEL.ZIP}</label>
                <div className='fullWidth positionRelative'>
                  <div className='fullWidth'>
                    <div className='width40 paddingRight35 zip'>
                      <input
                        placeholder="00000"
                        className="inputColum24size"
                        type="number"
                        min="0"
                        inputMode="numeric"
                        value={form.zip}
                        onChange={set("zip")}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className='width60 dependentResidencCol paddingLeft35 marginTop10 countryState'>
                      <div className={(county.label ? 'hasValue' : 'noValue') + ' fullWidth dependentResidencCol floatLeft positionRelative paddingLeft35 addressRow countryState'}>
                        <label className='labelCol institutionStateLabel'>{A12Y_CONST.LABEL.COUNTY}</label>
                        <Select
                          classNamePrefix={'dependentResidence'}
                          placeholder="Select"
                          value={county.label ? county : ""}
                          options={countyOptions}
                          onChange={(val) => setCounty(val)}
                          theme={(theme) => ({ ...theme, borderRadius: 0, colors: { ...theme.colors, primary: '#0096C708' } })}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* ── Action Buttons ── */}
              <div className="fullWidth textAlignRight displayFlexCol bottom_20_600 positionAbsouteBottom">
                <div className="widthAuto">
                  <input
                    className="cancelButton1"
                    onClick={handleCancelClick}
                    type="button"
                    value={A12Y_CONST.BUTTON_TEXT.GAURDIAN_PROFILE_PERSONAL_INFO_CANCEL}
                    disabled={loading}
                  />
                </div>
                <div className="widthAuto marginLeft20">
                  <div className="loaderSpinner">
                    {loading && <Loading />}
                    <input
                      id="AddDependentBtn"
                      className={loading || isBtnDisabled ? "saveButtonDisable" : "saveButton"}
                      disabled={loading || isBtnDisabled}
                      type="submit"
                      value={A12Y_CONST.BUTTON_TEXT.ADD_DEPENDENT}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <PopUpNewDependentConfirmation
        popUpStatus={isNewPopUp}
        popUpType={popUpType}
        subscription={subscription}
        currentCount={currentCount}
        proratedAmount={proratedAmount}
        nextBill={nextBill}
        onClose={() => { setIsNewPopUp(false); if (popUpType === A12Y_CONST.LABEL.QUOTA_LIMIT_REACHED) onCancel(); }}
        onConfirm={() => {
          setIsNewPopUp(false);
          if (pendingData) {
            onSubmit(pendingData.payload, pendingData.avatarFile);
          } 
        }}
      />
      <PopUpComponent
        popUpStatus={isCancelPopUp}
        title={A12Y_CONST.TEXT.ARE_YOU_SURE}
        message={A12Y_CONST.LABEL.ANY_EDITS_YOU}
        buttonDeleteTxt={A12Y_CONST.BUTTON_TEXT.YES}
        buttonCancelTxt={A12Y_CONST.BUTTON_TEXT.NO}
        hidePopUp={hideCancelPopUp}
        handleDeleteButton={handleConfirmCancel}
      />
    </div>
  );
}

export default AddNewDependentComponent;
